import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.qasm = languageMap.openqasm = bracketIndenting()
